import { connect } from 'react-redux';
import Categories from '../../categories';

const SelectRowAction = () => ({
  type: 'RowsTable',
  payload: Categories,
});

const SelectCheckboxAction = (item, checked) => ({
  type: 'SelectedItem',
  payload: { item, checked },
});

const DeleteCheckboxAction = (item) => ({
  type: 'RemoveSelected',
  payload: item,
});

const DeleteAllCheckboxAction = (item) => ({
  type: 'RemoveAllSelected',
  payload: item,
});

const FilterDataTable = (value) => ({
  type: 'FilterDataTable',
  payload: value,
});

export const withTableAction = (WrappedComponent) => connect(null, {
  SelectRowAction, SelectCheckboxAction, DeleteCheckboxAction, DeleteAllCheckboxAction, FilterDataTable
})(WrappedComponent);
